<style lang="less" scoped>
  #app {
    height: 100%;
    display: flex;
    flex-direction: column;
    > * {
      flex-shrink: 0;
    }
  }
  .section {
    flex: 1 0 auto;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 61px;
    border-top: 1px solid #e9edef;
    font-size: 13px;
    color: #808080;
  }
  .company-name {
    color: #ff6c00;
  }
  .footer-content-text {
    margin-left: 18px;
  }
</style>

<template lang="pug">
  #app
    section.section
      router-view
    footer(v-if="footer").footer
      span.company-name (주) 스타일닷컴
      span.footer-content-text 대표 박규도
      span.footer-content-text 사업자 등록번호 211-88-68398
      span.footer-content-text 서울특별시 송파구 송파대로 201 송파테라타워2 B동 1712호
      span.footer-content-text 고객센터 02-3442-3555
</template>

<script>
export default {
  mounted() {
    if (window.location.pathname === '/payment') {
      this.footer = false;
    }
  },
  data() {
    return {
      footer: true,
    };
  },
};
</script>
